import { type PropsWithChildren, useCallback, useState } from 'react';

import { ConversorCorticoideContext } from './context';

export const ConversorCorticoideProvider = ({
  children,
}: PropsWithChildren) => {
  const [drugOne, setDrugOne] = useState<string>('Prednisona');
  const [drugTwo, setDrugTwo] = useState<string>('Dexametasona');
  const [mg, setMg] = useState<number>(0);

  const handleDrugOne = useCallback((value: string): void => {
    setDrugOne(value);
  }, []);

  const handleDrugTwo = useCallback((value: string): void => {
    setDrugTwo(value);
  }, []);

  const handleMg = useCallback((value: number): void => {
    setMg(value);
  }, []);

  return (
    <ConversorCorticoideContext.Provider
      value={{
        drugOne,
        drugTwo,
        mg,
        setDrugOne: handleDrugOne,
        setDrugTwo: handleDrugTwo,
        setMg: handleMg,
      }}>
      {children}
    </ConversorCorticoideContext.Provider>
  );
};
